module.exports = __webpack_public_path__ + "media/images/odum_logo_big-ea35f92d5cb198be0257955fca4af315.png";